// Pure presentation helpers for the Order Detail view.
// Ported from the mockup's inline JS (lines ~844–848) — deterministic, no side-effects.

import type { Order, Marketplace, Payment } from "./types";

/** Display name for a marketplace channel. */
export function channelName(mkp: Marketplace | string): string {
  const MAP: Record<string, string> = {
    shopee: "Shopee",
    lazada: "Lazada",
    tiktok: "Tiktok",
  };
  return MAP[mkp] ?? String(mkp);
}

/**
 * Payment method display string. Prefers the marketplace's own label
 * (BE `payment_channel`, e.g. "SPayLater", "Cash on Delivery") so the UI
 * reads like the marketplace and legacy SynDi; falls back to the cod/prepaid
 * category when the feed carries no channel (CSV imports, older orders).
 */
export function payMethod(pay: Payment, payChannel?: string): string {
  if (payChannel && payChannel.toLowerCase() !== pay) return payChannel;
  const LABELS: Record<Payment, string> = {
    cod: "Cash on Delivery (COD)",
    prepaid: "Prepaid",
  };
  return LABELS[pay];
}

/**
 * Package number as Sino/SynDi show it: the marketplace order number with a
 * 1-based package suffix ("2610217X870R2S-1"). A marketplace-split order
 * (Lazada multi-package) carries its own index; everything else is -1.
 */
export function packageNo(order: Pick<Order, "sale" | "splitIndex">): string {
  const n = order.splitIndex && order.splitIndex > 0 ? order.splitIndex : 1;
  return `${order.sale}-${n}`;
}

/** Payment status derived from whether the marketplace's real pay_time (order.paidAt) is set. */
export function payStatusVal(order: Pick<Order, "paidAt">): string {
  return order.paidAt ? "PAYMENT_SUCCESS" : "PAYMENT_PENDING";
}
